import { Component, ChangeDetectionStrategy, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';

@Component({
  selector: 'automatic-messages-tab',
  template: `
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="'Automatic Messages - Full functionality coming soon'" />
      </tidy-row>
      <tidy-row class="extra-top-padding">
        <tidy-text [helper]="'This will include automated guest, pro, and tenant messaging templates with triggers, scheduling, and merge fields.'" />
      </tidy-row>
    </tidy-alert>
  `,
  standalone: true,
  imports: [TidyUiComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AutomaticMessagesTabComponent {}
